import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/@services/analytics.service';

export function appScrollTrackingInitializer() {
  return (): void => {
    const analyticsService = inject(AnalyticsService);
    const destroyRef = inject(DestroyRef);
    const scrollThresholds = [25, 50, 75, 90];
    let maxScrollDepth = 0;

    fromEvent(window, 'scroll')
      .pipe(
        debounceTime(100),
        map(() => calculateScrollDepth()),
        distinctUntilChanged(),
        tap((depth) => {
          if (depth > maxScrollDepth) {
            maxScrollDepth = depth;
            checkThresholds(depth, scrollThresholds, analyticsService);
          }
        }),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe();
  };
}

function calculateScrollDepth(): number {
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight - windowHeight;
  const scrollTop = window.scrollY;
  return Math.round((scrollTop / documentHeight) * 100);
}

function checkThresholds(
  depth: number,
  thresholds: number[],
  analyticsService: AnalyticsService
): void {
  thresholds.forEach((threshold) => {
    if (depth >= threshold) {
      analyticsService.trackEvent('scrollDepth', { depth: threshold });
    }
  });
}
